// import React, { useState, useRef, useEffect } from "react";

// import { useDispatch, useSelector } from "react-redux";
// import {
//   checkMobileDetailAsync,
//   selectMobileOtp,
//   setisMobileVerified,
// } from "../auth/authSlice";
// import {
//   fetchPartySignUpDetails,
//   resetConfirmed,
// } from "../PartyDetail/PartyDetailSlice";
// import { toast } from "react-toastify";
// import { selectPDEInfo } from "../user/userSlice";

// const MobileModal = ({
//   isOpen,
//   onClose,
//   onSuccess,
//   appointmentType,
//   activeTab,
// }) => {
//   const [mobileNo, setMobileNo] = useState("");
//   const [email, setEmail] = useState("");
//   const [otp, setOtp] = useState("");
//   const [regRadio, setRegRadio] = useState("");
//   const [Reg_Code, setReg_Code] = useState("");
//   const [otpResent, setOtpResent] = useState(false);
//   const [timer, setTimer] = useState(60);
//   const otpTimerRef = useRef(null);
//   const inputs = useRef([]);
//   const dispatch = useDispatch();
//   const pdeInfo = useSelector(selectPDEInfo);
//   const pdeData = pdeInfo?.pdeData[0];

//   const storedOTP = useSelector(selectMobileOtp);
//   const [isOtpDisabled, setIsOtpDisabled] = useState(false);

//   useEffect(() => {
//     if (isOtpDisabled && timer > 0) {
//       otpTimerRef.current = setInterval(() => {
//         setTimer((prev) => prev - 1);
//       }, 1000);
//     } else if (timer === 0) {
//       clearInterval(otpTimerRef.current);
//       setIsOtpDisabled(false);
//       setOtpResent(false);
//     }

//     return () => clearInterval(otpTimerRef.current);
//   }, [isOtpDisabled, timer]);

//   if (!isOpen) return null;

//   const handleOtpChange = (newOtp) => {
//     setOtp(newOtp);
//   };

//   const handleGetDetails = async () => {
//     debugger;
//     try {
//       // const response = await dispatch(
//       //   checkMobileDetailAsync(mobileNo)
//       // ).unwrap();
//       const response = await dispatch(
//         checkMobileDetailAsync({
//           mobile: mobileNo,
//           skipOtp: pdeData?.deedcode === "06" && activeTab === "secondParty",
//         })
//       ).unwrap();
//       debugger;
//       const { mobileOtp, email } = response;
//       console.log("OTP:", mobileOtp);
//       setEmail(email);
//       if (pdeData?.deedcode === "06" && activeTab === "secondParty") {
//         if (email) {
//           dispatch(fetchPartySignUpDetails(email))
//             .then((response) => {
//               console.log("User details fetched successfully:", response);
//             })
//             .catch((error) => {
//               console.error("Failed to fetch user details:", error);
//             });
//         }
//       }
//       // Start 30-second countdown
//       setIsOtpDisabled(true);
//       setOtpResent(true);
//       setTimer(30);
//     } catch (error) {
//       toast.error("Error");
//       console.error("Error checking mobileNo:", error.message);
//     }
//   };

//   const handleSubmitOTP = () => {
//     debugger;
//     if (otp === storedOTP) {
//       console.log("OTP Verified Successfully");
//       toast.success("OTP matched!");
//       dispatch(setisMobileVerified(true));
//       // if (onSuccess) {
//       //   onSuccess({ regRadio, Reg_Code });
//       // }
//       if (email) {
//         dispatch(fetchPartySignUpDetails(email))
//           .then((response) => {
//             console.log("User details fetched successfully:", response);
//           })
//           .catch((error) => {
//             console.error("Failed to fetch user details:", error);
//           });
//       }
//     } else {
//       console.error("Invalid OTP");
//       toast.error("Invalid Otp");
//     }
//   };

//   const handleInputChange = (index, e) => {
//     const digit = e.target.value.slice(-1);

//     if (/^\d$/.test(digit)) {
//       inputs.current[index].value = digit;
//       for (let i = index + 1; i < inputs.current.length; i++) {
//         if (inputs.current[i].value === "") {
//           inputs.current[i].focus();
//           break;
//         }
//       }
//     } else {
//       inputs.current[index].value = "";
//     }

//     setOtp(inputs.current.map((input) => input.value).join(""));
//   };

//   const handleKeyDown = (index, e) => {
//     if (e.key === "Backspace") {
//       if (inputs.current[index].value === "" && index > 0) {
//         inputs.current[index - 1].focus();
//       } else {
//         inputs.current[index].value = "";
//         e.preventDefault();
//       }
//     }
//   };

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//       <div className="bg-white rounded-lg p-6 w-full max-w-5xl 3xl:max-w-6xl h-auto">
//         <div className="flex justify-between items-center border-b-2 mb-2">
//           <h2 className="text-xl font-semibold">Mobile Verification</h2>
//           <button
//             onClick={() => {
//               dispatch(resetConfirmed());
//               onClose();
//             }}
//             className="text-gray-600 hover:text-gray-800"
//           >
//             &times;
//           </button>
//         </div>
//         <div className="flex flex-col md:flex-row">
//           {/* Left Section */}
//           <div className="w-full md:w-2/5">
//             <div className="mb-4 w-4/5">
//               <label
//                 className="block text-sm font-semibold mb-2"
//                 htmlFor="mobileNo"
//               >
//                 Mobile No.
//               </label>
//               <div className="grid grid-col-4 gap-4 items-start">
//                 <div className="col-span-1">
//                   <input
//                     type="text"
//                     id="mobileNo"
//                     value={mobileNo}
//                     onChange={(e) => setMobileNo(e.target.value)}
//                     className="custom-input xl:h-10 peer border-b-2 focus:border-gray-100 bg-gray-200 focus:outline-none focus:ring-0"
//                     placeholder="Enter Mobile No."
//                   />
//                 </div>

//                 <div className="col-span-1">
//                   <button
//                     className={`w-full h-8 ${
//                       isOtpDisabled
//                         ? "bg-gray-400 cursor-not-allowed"
//                         : "bg-blue-500 hover:bg-blue-600"
//                     } text-white py-1 px-4 rounded-md text-sm`}
//                     onClick={handleGetDetails}
//                     disabled={isOtpDisabled}
//                   >
//                     Get OTP
//                   </button>
//                   {isOtpDisabled && (
//                     <p className="text-xs text-gray-500 mt-1 text-center">
//                       Please wait {timer} second{timer !== 1 && "s"} before
//                       requesting OTP again.
//                     </p>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Right Section */}
//           <div className="w-full md:w-3/5 flex items-center justify-center p-6 mx-0 rounded-lg">
//             <div className="text-center 3xl:w-4/5 bg-[#D2E3EB] p-12 rounded-lg">
//               <p className="text-sm text-gray-900">
//                 <span className="text-red-500">*</span> Enter mobile number and
//                 captcha (in the format shown) and click ‘Get OTP’ to confirm it.
//                 An OTP will be sent to your phone via SMS. Copy the OTP from the
//                 SMS and enter it into the OTP box, then click the “Submit”
//                 button.
//               </p>
//             </div>
//           </div>
//         </div>
//         <div className="mb-4">
//           <label className="block text-sm font-semibold mb-2" htmlFor="otp">
//             Enter OTP
//           </label>
//           <div className="flex items-center space-x-2">
//             <div className="flex space-x-2">
//               {[...Array(4)].map((_, index) => (
//                 <input
//                   key={index}
//                   type="text"
//                   maxLength={1}
//                   className="form-control text-center w-10 border-gray-300 rounded-md shadow-sm"
//                   ref={(el) => (inputs.current[index] = el)}
//                   onChange={(e) => handleInputChange(index, e)}
//                   onKeyDown={(e) => handleKeyDown(index, e)}
//                 />
//               ))}
//             </div>
//             <button
//               className="w-28 h-10 bg-blue-500 text-white py-1 px-4 rounded-full hover:bg-blue-600 text-sm"
//               onClick={handleSubmitOTP}
//             >
//               Submit OTP
//             </button>
//           </div>

//           <div className="text-center mt-2">
//             {otpResent && (
//               <p className="text-sm text-gray-500">
//                 Resend OTP:{" "}
//                 <span>{timer < 10 ? `00:0${timer}` : `00:${timer}`}</span>
//               </p>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default MobileModal;

import React, { useState, useRef, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  checkMobileDetailAsync,
  selectMobileOtp,
  setisMobileVerified,
} from "../auth/authSlice";
import {
  fetchPartySignUpDetails,
  resetConfirmed,
} from "../PartyDetail/PartyDetailSlice";
import { toast } from "react-toastify";
import { selectPDEInfo } from "../user/userSlice";

const MobileModal = ({
  isOpen,
  onClose,
  onSuccess,
  appointmentType,
  activeTab,
}) => {
  const [mobileNo, setMobileNo] = useState("");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [regRadio, setRegRadio] = useState("");
  const [Reg_Code, setReg_Code] = useState("");
  const [otpResent, setOtpResent] = useState(false);
  const [timer, setTimer] = useState(60);
  const otpTimerRef = useRef(null);
  const inputs = useRef([]);

  const dispatch = useDispatch();
  const pdeInfo = useSelector(selectPDEInfo);
  const pdeData = pdeInfo?.pdeData?.[0];
  const storedOTP = useSelector(selectMobileOtp);

  const [isOtpDisabled, setIsOtpDisabled] = useState(false);

  // special-case: deedcode "06" + secondParty => no OTP, but need 10-digit mobile
  const isSecondPartyNoOtp = useMemo(
    () => pdeData?.deedcode === "06" && activeTab === "secondParty",
    [pdeData?.deedcode, activeTab]
  );

  const isValidMobile = /^\d{10}$/.test(mobileNo);
  const isOtpLengthValid = otp?.length === 4;

  useEffect(() => {
    if (isSecondPartyNoOtp) return; // skip timer in no-OTP flow

    if (isOtpDisabled && timer > 0) {
      otpTimerRef.current = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      clearInterval(otpTimerRef.current);
      setIsOtpDisabled(false);
      setOtpResent(false);
    }
    return () => clearInterval(otpTimerRef.current);
  }, [isOtpDisabled, timer, isSecondPartyNoOtp]);

  if (!isOpen) return null;

  const afterEmailFetch = (emailToUse) => {
    if (emailToUse) {
      dispatch(fetchPartySignUpDetails(emailToUse))
        .then((res) => {
          console.log("User details fetched successfully:", res);
        })
        .catch((err) => {
          console.error("Failed to fetch user details:", err);
        });
    }
  };

  const handleGetDetails = async () => {
    try {
      if (!isValidMobile) {
        toast.warn("Please enter a valid 10-digit mobile number.");
        return;
      }

      const response = await dispatch(
        checkMobileDetailAsync({
          mobile: mobileNo,
          skipOtp: isSecondPartyNoOtp,
        })
      ).unwrap();

      const { mobileOtp, email: emailFromApi } = response || {};
      setEmail(emailFromApi || "");

      if (isSecondPartyNoOtp) {
        // Direct fetch without OTP
        afterEmailFetch(emailFromApi);
        dispatch(setisMobileVerified(true));
        toast.success("Details fetched successfully.");
        return;
      }

      // OTP flow
      if (mobileOtp) {
        setIsOtpDisabled(true);
        setOtpResent(true);
        setTimer(30);
        toast.info("OTP sent to your mobile.");
      }
    } catch (error) {
      toast.error("Error while processing the request.");
      console.error("Error checking mobileNo:", error?.message || error);
    }
  };

  const handleSubmitOTP = () => {
    if (!isOtpLengthValid) {
      toast.warn("Please enter the 4-digit OTP.");
      return;
    }

    if (otp === storedOTP) {
      toast.success("OTP verified!");
      dispatch(setisMobileVerified(true));
      afterEmailFetch(email);
      // onSuccess?.({ regRadio, Reg_Code });
    } else {
      toast.error("Invalid OTP");
    }
  };

  const handleInputChange = (index, e) => {
    const digit = e.target.value.replace(/\D/g, "").slice(-1);
    inputs.current[index].value = digit || "";

    if (digit) {
      for (let i = index + 1; i < inputs.current.length; i++) {
        if (inputs.current[i].value === "") {
          inputs.current[i].focus();
          break;
        }
      }
    }

    setOtp(inputs.current.map((input) => input.value || "").join(""));
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      if (inputs.current[index].value === "" && index > 0) {
        inputs.current[index - 1].focus();
      } else {
        inputs.current[index].value = "";
        e.preventDefault();
      }
      setOtp(inputs.current.map((input) => input.value || "").join(""));
    }
  };

  const handleMobileChange = (e) => {
    const onlyDigits = e.target.value.replace(/\D/g, "").slice(0, 10);
    setMobileNo(onlyDigits);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-5xl 3xl:max-w-6xl h-auto">
        <div className="flex justify-between items-center border-b-2 mb-2">
          <h2 className="text-xl font-semibold">Mobile Verification</h2>
          <button
            onClick={() => {
              dispatch(resetConfirmed());
              onClose();
            }}
            className="text-gray-600 hover:text-gray-800"
          >
            &times;
          </button>
        </div>

        <div className="flex flex-col md:flex-row">
          {/* Left Section (UNCHANGED LAYOUT) */}
          <div className="w-full md:w-2/5">
            <div className="mb-4 w-4/5">
              <label
                className="block text-sm font-semibold mb-2"
                htmlFor="mobileNo"
              >
                Mobile No.
              </label>

              <div className="grid grid-col-4 gap-4 items-start">
                <div className="col-span-1">
                  <input
                    type="text"
                    id="mobileNo"
                    value={mobileNo}
                    onChange={handleMobileChange}
                    className="custom-input xl:h-10 peer border-b-2 focus:border-gray-100 bg-gray-200 focus:outline-none focus:ring-0"
                    placeholder="Enter Mobile No."
                    inputMode="numeric"
                    autoComplete="tel"
                  />
                </div>

                <div className="col-span-1">
                  <button
                    className={`w-full h-8 ${
                      // disable style
                      (
                        isSecondPartyNoOtp
                          ? !isValidMobile
                          : isOtpDisabled || !isValidMobile
                      )
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-blue-500 hover:bg-blue-600"
                    } text-white py-1 px-4 rounded-md text-sm`}
                    onClick={handleGetDetails}
                    disabled={
                      isSecondPartyNoOtp
                        ? !isValidMobile
                        : isOtpDisabled || !isValidMobile
                    }
                  >
                    {isSecondPartyNoOtp ? "Get Details" : "Get OTP"}
                  </button>

                  {/* Cooldown text only for OTP flow */}
                  {!isSecondPartyNoOtp && isOtpDisabled && (
                    <p className="text-xs text-gray-500 mt-1 text-center">
                      Please wait {timer} second{timer !== 1 && "s"} before
                      requesting OTP again.
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Right Section (same container, copy changed text only) */}
          <div className="w-full md:w-3/5 flex items-center justify-center p-6 mx-0 rounded-lg">
            <div className="text-center 3xl:w-4/5 bg-[#D2E3EB] p-12 rounded-lg">
              {isSecondPartyNoOtp ? (
                <p className="text-sm text-gray-900">
                  <span className="text-red-500">*</span> Enter mobile number
                  and click “Get Details” to fetch data. OTP is not required for
                  this flow.
                </p>
              ) : (
                <p className="text-sm text-gray-900">
                  <span className="text-red-500">*</span> Enter mobile number
                  and click “Get OTP”. An OTP will be sent via SMS. Enter the
                  OTP below and click “Submit”.
                </p>
              )}
            </div>
          </div>
        </div>

        {/* OTP Section — hidden only for deedcode 06 + secondParty */}
        {!isSecondPartyNoOtp && (
          <div className="mb-4">
            <label className="block text-sm font-semibold mb-2" htmlFor="otp">
              Enter OTP
            </label>

            <div className="flex items-center space-x-2">
              <div className="flex space-x-2">
                {[...Array(4)].map((_, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength={1}
                    className="form-control text-center w-10 border-gray-300 rounded-md shadow-sm"
                    ref={(el) => (inputs.current[index] = el)}
                    onChange={(e) => handleInputChange(index, e)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                    inputMode="numeric"
                  />
                ))}
              </div>

              <button
                className={`w-28 h-10 ${
                  isOtpLengthValid
                    ? "bg-blue-500 hover:bg-blue-600"
                    : "bg-gray-400 cursor-not-allowed"
                } text-white py-1 px-4 rounded-full text-sm`}
                onClick={handleSubmitOTP}
                disabled={!isOtpLengthValid}
              >
                Submit OTP
              </button>
            </div>

            <div className="text-center mt-2">
              {otpResent && (
                <p className="text-sm text-gray-500">
                  Resend OTP:{" "}
                  <span>{timer < 10 ? `00:0${timer}` : `00:${timer}`}</span>
                </p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MobileModal;
